const input = {
    username: 'Benutzername',
    password: 'Passwort',
    email: 'Email',
    phone_number: 'Telefonnummer',
    confirm_password: 'Passwort bestätigen',
    search_region_code: 'Suche region code',
    backup_code: 'Backup-Code',
    code: 'Code',
    label_with_optional: '{{label}} (Optional)',
};
export default Object.freeze(input);
